module.exports = __webpack_public_path__ + "img/greenUp.2b38e3f8.svg";